/**
 * Presentación de apoyo para Crear Mensajes.
 *
 * Opción A (recomendada con vídeos incrustados): graba el PowerPoint como MP4 y guárdalo en
 *   public/crearMensajes/presentacion.mp4
 *
 * Opción B: exporta el .pptx como PDF en
 *   public/crearMensajes/presentacion.pdf
 *
 * Opción C: exporta cada diapositiva como JPG en
 *   public/crearMensajes/slides/slide-01.jpg … slide-59.jpg
 *   y cambia PRESENTACION_MODE a "images".
 */

const publicBase = process.env.PUBLIC_URL || "";

export const PRESENTACION_MODE = "video";

export const PRESENTACION_VIDEO_URL = `${publicBase}/crearMensajes/presentacion.mp4`;

export const PRESENTACION_PDF_URL = `${publicBase}/crearMensajes/presentacion.pdf`;

export const PRESENTACION_SLIDE_COUNT = 59;

export const slideImageUrl = (index) =>
  `${publicBase}/crearMensajes/slides/slide-${String(index).padStart(2, "0")}.jpg`;
